import {
  IParameterCondition,
  ISVGAnimationsSettings,
  ISVGColorSettings,
  ISVGSettings,
  ISVGVisibilitySettings,
} from './svgChart.types'
import { TLastValuesDataRef } from '../../../../services/data/data.types'

const isConditionMatch = (condition: IParameterCondition, value: number) => {
  if (value == null) {
    return false
  }

  switch (condition.condition) {
    case '<':
      return value < condition.value
    case '<=':
      return value <= condition.value
    case '=':
      return value === condition.value
    case '>':
      return value > condition.value
    case '>=':
      return value >= condition.value
  }
}

const settingsKeys = ['color', 'movements', 'rotations', 'visibility'] as const
const computeMatches = (
  settings: ISVGSettings,
  data: TLastValuesDataRef
): {
  color: Array<ISVGColorSettings & { isMatch: boolean }>
  movements: Array<ISVGAnimationsSettings & { isMatch: boolean }>
  rotations: Array<ISVGAnimationsSettings & { isMatch: boolean }>
  visibility: Array<ISVGVisibilitySettings & { isMatch: boolean }>
} => {
  const result = {
    color: [],
    visibility: [],
    rotations: [],
    movements: [],
  }

  for (const key of settingsKeys) {
    for (const row of settings[key]) {
      const conditionResult = isConditionMatch(row, data?.[row.device_id]?.[row.parameter_id] || 0)
      result[key].push({ ...row, isMatch: conditionResult })
    }
  }

  return result
}

const svgConditions = { computeMatches }
export default svgConditions
